import { memo } from 'react';
import { Icon, Text, RoundedCard } from '../../components';
import { content } from './content';
import bgImage1 from "../../assets/images/bg-image1.png";
import "./TeamOfProfessionals.scss";

function MemoComponent({id}: { id: string}) {
  return (
    <section id={id} className="team-of-professionals">
      <div className="section-content">
        <div>
          <Text variant="title2" weight={700} align="center" className="mb-10">
            {content.title}
          </Text>

          <Text variant="subtitle2" weight={700} align="center">
            {content.subtitle}
          </Text>
        </div>

        <Text variant="content3" align="center" color="tertiary">
          {content.paragraph1}
        </Text>

        <div className="display-flex flex-wrap justify-center align-center gap-30">
          <RoundedCard>
            <Icon className="icon-brightness" size={24} containerClassName="icon-blue-bg mb-30"/>

            <Text variant="subtitle2" weight={700} className="mb-30">
              {content.productCard.title}
            </Text>

            <Text variant="content3" color="tertiary">
              {content.productCard.paragraph1}
            </Text>
          </RoundedCard>

          <RoundedCard>
            <Icon className="icon-display" size={24} containerClassName="icon-blue-bg mb-30"/>

            <Text variant="subtitle2" weight={700} className="mb-30">
              {content.graphicCard.title}
            </Text>

            <Text variant="content3" color="tertiary">
              {content.graphicCard.paragraph1}
            </Text>
          </RoundedCard>
        </div>
      </div>

      <img src={bgImage1} alt="background decorators" className="bg-image"/>
    </section>
  )
}

export const TeamOfProfessionals = memo(MemoComponent);